function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#202020",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.1,
  cy: 16.8,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.9,
  cy: 16.8,
  r: 5.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5.2,
  r: 5.1
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22"
  }, props), _ref);
};

export default SvgComponent;